import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import supProductOfferingService from "services/Setup/Organization/supProductOfferingService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  subProductOfferingList: [],
};

export const postSubProductOffering = createAsyncThunk(
  "subProductOffering/postSubProductOffering",
  async (data, { rejectWithValue }) => {
    try {
      const response = await supProductOfferingService.postSubProductOffering(
        data
      );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const puttSubProductOffering = createAsyncThunk(
  "subProductOffering/puttSubProductOffering",
  async (data, { rejectWithValue }) => {
    console.log("puttSubProductOffering slice  ", data);
    try {
      const response = await supProductOfferingService.puttSubProductOffering(
        data
      );
  
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const deleteProductOfferingCharges = createAsyncThunk(
  "subProductOffering/deleteProductOfferingCharges",
  async (data, { rejectWithValue }) => {
    console.log("deleteProductOfferingCharges slice  ", data);
    try {
      const response =
        await supProductOfferingService.deleteProductOfferingCharges(data);
      console.log("deleteProductOfferingCharges response  ", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else { 
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getsubproductOfferingApproval = createAsyncThunk(
  "subProductOffering/getsubproductOfferingApproval",
  async (data, { rejectWithValue }) => {
    console.log("getsubproductOfferingApproval");
    try {
      const response =
        await supProductOfferingService.getsubproductOfferingApproval(data);
      console.log("getsubproductOfferingApproval", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getsubproductOffering = createAsyncThunk(
  "subProductOffering/getsubproductOffering",
  async (data, { rejectWithValue }) => { 
    try {
      const response = await supProductOfferingService.getsubproductOffering(
        data
      );
      console.log("getsubproductOfferinglist", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("getsubproductOfferinglist error", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getSelectSubproductOffering = createAsyncThunk(
  "subProductOffering/getSelectSubproductOffering",
  async (data, { rejectWithValue }) => {
    console.log("getSelectSubproductOfferinglist tess", data);
    try {
      const response =
        await supProductOfferingService.getSelectSubproductOffering(data);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("getSelectSubproductOfferinglist error", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getsubProductOfferingDetail = createAsyncThunk(
  "subProductOffering/getsubProductOfferingDetail",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await supProductOfferingService.getsubProductOfferingDetail(data);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const updatesubProductOffering = createAsyncThunk(
  "subProductOffering/updatesubProductOffering",
  async (data, { rejectWithValue }) => {
    try {
      const response = await supProductOfferingService.updatesubProductOffering(
        data
      );
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const deletesubProductOffering = createAsyncThunk(
  "subProductOffering/deletesubProductOffering",
  async (data, { rejectWithValue }) => {
    try {
      const response = await supProductOfferingService.deletesubProductOffering(
        data
      );
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getsubproductOfferingSerch = createAsyncThunk(
  "subProductOffering/getsubproductOfferingSerch",
  async (data, { rejectWithValue }) => { 
    try {
      console.log('data getsubproductOfferingSerchqwertyuio',data);
      const response =
        await supProductOfferingService.getsubproductOfferingSerch(data); 
        console.log('responsegetsubproductOfferingSerchqwertyuio',response);
        
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log('error getsubproductOfferingSerchqwertyuio',data)
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getsubproductOfferingSerchItem = createAsyncThunk(
  "subProductOffering/getsubproductOfferingSerchItem",
  async (data, { rejectWithValue }) => { 
    try {
      console.log('data getsubproductOfferingSerchItemqwertyuio',data);
      const response =
        await supProductOfferingService.getsubproductOfferingSerchItem(data); 
        console.log('responsegetsubproductOfferingSerchItemqwertyuio',response);
        
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log('error getsubproductOfferingSerchqwertyuio',data)
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const subproductOfferingApproval = createAsyncThunk(
  "subProductOffering/subproductOfferingApproval",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await supProductOfferingService.subproductOfferingApproval(data);
      console.log("subproductOfferingApproval", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const productOfferingReturn = createAsyncThunk(
  "subProductOffering/productOfferingReturn",
  async (data, { rejectWithValue }) => {
    try {
      const response = await supProductOfferingService.productOfferingReturn(
        data
      );
      console.log("productOfferingReturn", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);
export const ProductOfferingRequest = createAsyncThunk(
  "subProductOffering/ProductOfferingRequest",
  async (data, { rejectWithValue }) => {
    try {
      const response = await supProductOfferingService.ProductOfferingRequest(
        data
      );
      console.log("ProductOfferingRequest", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);
export const ProductOfferingReject = createAsyncThunk(
  "subProductOffering/ProductOfferingReject",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ ProductOfferingRejectdata:", data);
    try {
      const response = await supProductOfferingService.ProductOfferingReject(
        data
      );
      console.log("ProductOfferingReject", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const uploadProductOffering = createAsyncThunk(
  "subProductOffering/uploadProductOffering",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~uploadProductOffering data:", data);
    try {
      const response = await supProductOfferingService.uploadProductOffering(
        data
      );
      console.log("🚀 ~ response:", response);

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ postProductCollection error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const subProductOfferingSlice = createSlice({
  name: "subProductOffering",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    falseMessage: (state) => {
      state.message = "";
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //post
      .addCase(postSubProductOffering.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(postSubProductOffering.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(postSubProductOffering.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //put
      .addCase(puttSubProductOffering.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(puttSubProductOffering.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(puttSubProductOffering.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //delete
      .addCase(deleteProductOfferingCharges.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(deleteProductOfferingCharges.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(deleteProductOfferingCharges.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //list approval
      .addCase(getsubproductOfferingApproval.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getsubproductOfferingApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.subProductOfferingList = action.payload.data.data;
        state.getCount = action.payload.data.count;
      })
      .addCase(getsubproductOfferingApproval.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //list
      .addCase(getsubproductOffering.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getsubproductOffering.fulfilled, (state, action) => {
        console.log("getsubproductOffering action--", action.payload.data.data);
        state.loading = false;
        state.subProductOfferingList = action.payload.data.data;
        state.getCount = action.payload.data.count;
        console.log("action");
      })
      .addCase(getsubproductOffering.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //list search
      .addCase(getsubproductOfferingSerch.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getsubproductOfferingSerch.fulfilled, (state, action) => {
        
        state.loading = false;
        state.subProductOfferingList = action.payload.data.data;
        state.getCount = action.payload.data.count;
        console.log("action");
      })
      .addCase(getsubproductOfferingSerch.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //list search item
      .addCase(getsubproductOfferingSerchItem.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getsubproductOfferingSerchItem.fulfilled, (state, action) => {
        
        state.loading = false;
        state.subProductOfferingList = action.payload.data.data;
        state.getCount = action.payload.data.count;
        console.log("action");
      })
      .addCase(getsubproductOfferingSerchItem.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //select product offering
      .addCase(getSelectSubproductOffering.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSelectSubproductOffering.fulfilled, (state, action) => {
        console.log(
          "getSelectSubproductOffering action",
          action.payload.data.data
        );
        state.loading = false;
        state.subProductOfferingList = action.payload.data.data;
        state.getCount = action.payload.data.count;
        console.log("action");
      })
      .addCase(getSelectSubproductOffering.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //detail
      .addCase(getsubProductOfferingDetail.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(getsubProductOfferingDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(getsubProductOfferingDetail.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //update
      .addCase(updatesubProductOffering.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(updatesubProductOffering.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
      })
      .addCase(updatesubProductOffering.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //delete
      .addCase(deletesubProductOffering.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(deletesubProductOffering.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deletesubProductOffering.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Approval
      .addCase(subproductOfferingApproval.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(subproductOfferingApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(subproductOfferingApproval.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Approval
      .addCase(productOfferingReturn.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(productOfferingReturn.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(productOfferingReturn.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Approval
      .addCase(ProductOfferingRequest.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(ProductOfferingRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(ProductOfferingRequest.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Reject
      .addCase(ProductOfferingReject.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(ProductOfferingReject.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(ProductOfferingReject.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //upload sub fee charges
      .addCase(uploadProductOffering.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadProductOffering.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(uploadProductOffering.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, falseMessage, hideNotification, showLoading } =
  subProductOfferingSlice.actions;

export default subProductOfferingSlice.reducer;
